import React from 'react';
import moment from 'moment';

const SVGHelper = {
    title: (value) => {
        const titleProps = {
            width: '100%',
            height: '55',
            style: {
                fill: '#1E252E',
                fontSize: '36px',
                fontWeight: 400,
            },
        };

        return (
            <svg {...titleProps}>
                <text y={35}>{value}</text>
            </svg>
        );
    },
    main: ({ mainValue, extraValue, specialColor }) => {
        const mainProps = {
            fontSize: 80,
            fontWeight: 500,
        };

        const extraProps = {
            fontSize: 30,
            fontWeight: 400,
            y: 60,
            style: { marginLeft: '20px' }
        };

        if (specialColor) {
            mainProps.fill = specialColor;
            extraProps.fill = specialColor;
        }

        let value = <text y={60} {...mainProps}>{mainValue}</text>;
        if (extraValue) {
            value = (
                <text y={60}>
                    <tspan width="100%" height="90" {...mainProps}>
                        {mainValue}
                    </tspan>
                    <tspan {...extraProps}>
                        {extraValue}
                    </tspan>
                </text>
            );
        }

        return (
            <svg width="100%" height="90">
                {value}
            </svg>
        );
    },
};

const CompetitionTimeLeftWidget = (props) => {
    const { widget, companyProfile, slide } = props;
    let maxDate = slide ? slide.competitionSettings.maxDate : '2019-01-01';
    const today = moment();
    const endDate = moment(maxDate);
    let daysLeft = endDate.diff(today, 'days') + 1;

    let daysText = 'days';
    if (daysLeft == 1) daysText = 'day';
    if (daysLeft <= 0) daysLeft = 0;

    const customTextColor = slide ? slide.custom.bgColor : companyProfile.colors.mainBg;

    return (
        <div className="competition-time-left-widget">
            {SVGHelper.title('Time left')}
            {SVGHelper.main({ mainValue: daysLeft, extraValue: daysText, specialColor: customTextColor })}
        </div>
    );
};

CompetitionTimeLeftWidget.propTypes = {
    slide: React.PropTypes.object,
};

export default CompetitionTimeLeftWidget;


/** WEBPACK FOOTER **
 ** ./client/components/Widgets/CompetitionWidgets/CompetitionTimeLeftWidget.jsx
 **/